import CALL_CENTER_ONLINE_TIME_TRACKING_MUTATION from '@/shared/api/mutations/callCenterOnlineTimeTracking';
import createClient from '../client/apolloClient';

export type CallCenterOnlineTimeTrackingResult = {
  isSuccess: boolean;
  message: string;
};

// TODO(ts): typed as the CallCenterOnlineTimeTrackingInput GraphQL input once its server-side shape is documented
/**
 * Reports this call-center tab as online to the server. Runs the online time tracking mutation and throws the server message when it does not report success.
 *
 * @param input - Mutation input carrying the tab id, tab name and browser.
 * @returns A promise resolving once the online-time sample has been accepted.
 */
const handleCallCenterOnlineTimeTracking = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<{
    callCenterOnlineTimeTracking: CallCenterOnlineTimeTrackingResult;
  }>({
    mutation: CALL_CENTER_ONLINE_TIME_TRACKING_MUTATION,
    variables: {
      input,
    },
  });
  if (!result?.data?.callCenterOnlineTimeTracking?.isSuccess) {
    throw new Error(result?.data?.callCenterOnlineTimeTracking?.message);
  }
};

export default handleCallCenterOnlineTimeTracking;
